/**
 * Created by amirb on 4/12/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var WidgetStateBase = require('web-agent-widgets/WidgetStateBase');

    var CoBrowseWidget = WidgetStateBase.extend({
        ControllerName: 'CoBrowse',
        applicationType: 'CoBrowse',
        singleton: false,
        iframe: true,
        span: 4,
        LPViewMap: {
            iframe_tag: '.lpview_iframe_tag',
            widgetWrapper: '.cobrowse_widget_wrapper',
            closeButton: '.lpview_close_button',
            toggleMaximize: '.lpview_toggle_maximize',
            ribbonTitle: '.lpview_ribbon_title',
            ribbonPlachHolder: '.lpview_cobrowse_ribbon_placeholder'
        },
        RibbonStateMap: {
            collapsed: 'collapse'
        },
        initialize: function (constructorData) {
            //this.isMaximized = false;
            this.iframeView = this.getFirstElement(this.LPViewMap.iframe_tag);
            this.iframeView.src = constructorData.url;
            this.span = constructorData.span;
            this.prohibitTranslation = true;

            this.widget = this.getFirstElement(this.LPViewMap.widgetWrapper);
            this.closeButton = this.getFirstElement(this.LPViewMap.closeButton);
            //this.toggleButton = this.getFirstElement(this.LPViewMap.toggleMaximize);
            this.ribbonTitle = this.getFirstElement(this.LPViewMap.ribbonTitle);

            //this.widgetBaseElement = this.widget.parentNode;
            //this.appRootElm = document.querySelector('.root');

            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
            var tag = this.getModelParam(participantPath + '.participantTag');

            this.addClass(this.widget, tag);

            // set the title:
            switch (constructorData.cobrowseMode) {
                case 'VIDEO_CALL':
                    this.ribbonTitle.innerHTML = this.translate("VIDEO_CALL_RIBBON_TITLE");
                    break;
                case 'VOICE_CALL':
                    this.ribbonTitle.innerHTML = this.translate("VOICE_CALL_RIBBON_TITLE");
                    break;
                default:
                    this.ribbonTitle.innerHTML = this.translate("COBROWSE_RIBBON_TITLE");
            }

            // note: learn about the timer manager.
            this.initializeRibbonVisibilityTimeoutRef = setTimeout(initializeRibbonVisibility.bind(this), 5000);

            function initializeRibbonVisibility() {
                this.setRibbonVisibility(false);
            }
        },

        events: function () {

            this.bindViewEvent({
                selector: this.LPViewMap.closeButton,
                DOMEvent: "click",
                callback: this.closeSession.bind(this)
            });

            this.bindViewEvent({
                selector: this.LPViewMap.ribbonPlachHolder,
                DOMEvent: 'mouseenter',
                callback: this.OnMouseEnterHandler
            });

            this.bindViewEvent({
                selector: this.LPViewMap.ribbonPlachHolder,
                DOMEvent: 'mouseleave',
                callback: this.OnMouseLeaveHandler
            });

            //this.bindViewEvent({
            //    selector: this.LPViewMap.toggleMaximize,
            //    DOMEvent: "click",
            //    callback: this.toggleMaximize.bind(this)
            //});

        }
    });

    CoBrowseWidget.prototype.OnMouseEnterHandler = function () {
        this.setRibbonVisibility(true);
    };

    CoBrowseWidget.prototype.OnMouseLeaveHandler = function () {
        this.setRibbonVisibility(false);
    };

    CoBrowseWidget.prototype.setRibbonVisibility = function (isShow) {
        if (isShow) {
            this.removeClass(this.LPViewMap.ribbonPlachHolder, this.RibbonStateMap.collapsed);
        } else {
            this.addClass(this.LPViewMap.ribbonPlachHolder, this.RibbonStateMap.collapsed);
        }
    };

    CoBrowseWidget.prototype.updateUrl = function (url) {
        if (url) {
            this.iframeView.src = url;
        }
    };

    CoBrowseWidget.prototype.closeSession = function () {
        //this.minimize();
        this.iframeView.src = 'about:blank';
        clearTimeout(this.initializeRibbonVisibilityTimeoutRef);
        lpTag.WebAgent.coBrowseController.endSession();
    };

    CoBrowseWidget.prototype.getConfiguration = function () {
        var configuration = {
            templateFile: 'lp_cobrowse_iframe_widget.html'
        };
        return configuration;
    };


    //CoBrowseWidget.prototype.visitorBlurred = function(){
    //    this.minimize();
    //    WidgetViewController.prototype.visitorBlurred.call(this);
    //};

    //CoBrowseWidget.prototype.toggleMaximize = function(){
    //    if(this.isMaximized) {
    //        this.minimize();
    //    }
    //    else{
    //        this.maximize();
    //    }
    //};

    //CoBrowseWidget.prototype.maximize = function () {
    //    if(this.widgetPH === this.appRootElm) {
    //        return;
    //    }
    //
    //    //this.widgetBaseElement.removeChild(this.widget);
    //    //this.widgetPH = this.appRootElm;
    //    this.appRootElm.appendChild(this.widget);
    //
    //    this.addClass(this.toggleButton, 'maximized');
    //    this.addClass(this.widget, 'maximized');
    //    this.isMaximized = true;
    //};
    //
    //CoBrowseWidget.prototype.minimize = function () {
    //    if(this.widgetPH === this.widgetBaseElement){
    //        return;
    //    }
    //
    //    //this.appRootElm.removeChild(this.widget);
    //    //this.widgetPH = this.widgetBaseElement;
    //    this.widgetBaseElement.appendChild(this.widget);
    //
    //    this.removeClass(this.widget, 'maximized');
    //    this.removeClass(this.toggleButton, 'maximized');
    //    this.isMaximized = false;
    //
    //};

    // todo - lose this global namespace

    // TODO: figure why i cant attach it to the webAgent namespace and retrieve it on the main widget window.
    window.CoBrowseWidget = CoBrowseWidget;

    return CoBrowseWidget;

});
